<template>
  <div
    class="person-avatar-item"
    :class="{ 'person-avatar-item--selected': selected }"
  >
    <q-avatar
      :size="size"
      color="grey-3"
      text-color="grey-6"
      class="cursor-pointer person-avatar-item__avatar"
      @click="$emit('click')"
    >
      <q-img
        v-if="person.primaryFace && person.primaryFace.imageUrl"
        :src="person.primaryFace.imageUrl"
        :ratio="1"
        fit="cover"
      >
        <template v-slot:error>
          <q-icon name="fa fa-user" size="sm" />
        </template>
      </q-img>
      <q-icon v-else name="fa fa-user" size="sm" />
      <q-tooltip :delay="300" :offset="[0, 6]">
        <span :class="{ 'text-grey-5': !person.label }">{{ person.label || 'Unnamed' }}</span>
      </q-tooltip>
    </q-avatar>
    <q-badge
      v-if="person.faceCount"
      color="primary"
      floating
      class="face-count-badge"
    >
      {{ person.faceCount }}
    </q-badge>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Person } from '@/analysis/types';

export default defineComponent({
  emits: ['click'],
  props: {
    person: {
      type: Object as () => Person,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '80px',
    },
  },
});
</script>

<style scoped>
.person-avatar-item {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.person-avatar-item--selected .cursor-pointer {
  outline: 3px solid var(--q-primary);
  outline-offset: 2px;
}

.person-avatar-item--selected :deep(.q-img__image) {
  filter: grayscale(100%);
}

.person-avatar-item__avatar {
  overflow: hidden;
}

.face-count-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 10px;
  padding: 2px 5px;
  min-height: 16px;
  line-height: 1;
}
</style>
